import { render, staticRenderFns } from "./OnOffSimple.vue?vue&type=template&id=08092b18"
import script from "./OnOffSimple.vue?vue&type=script&lang=js"
export * from "./OnOffSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports